import React from 'react';
import { Page } from '../../components/ui/Page';
import { Body } from '../../components/layout/Body';
import Store from '../../store/Store';
import CheckoutForm from './Checkout';

export interface PaymentPageProps {
	id?: string;
}

export default function PaymentPage({ id }: PaymentPageProps) {
	const selectedOrder = Store.use('selectedOrder') as unknown as {
		orderId: string;
		mission: string;
	} | undefined;

	if (!selectedOrder) return null;

	return (
		<Page center>
			<div className="mt-20">
			<Body title="Jetzt bezahlen">
				<CheckoutForm
					productKey={
						selectedOrder.mission === '"Landwirtschaft"' ? 'l2' : 'v2'
					}
					orderId={selectedOrder.orderId}
					returnParam="nachzahlung=1"
				/>
			</Body>
			</div>
		</Page>
	);
}
